import sted from "../img/logo.png";
import { cn } from "@/lib/utils";

type LogoProps = {
  className?: string;
  size?: "sm" | "md" | "lg";
};

export const StedIcon = ({ className, size }: LogoProps) => (
  <span className={cn(" justify-center items-center", className)}>
    <img
      src={sted}
      className={cn("w-auto", {
        "h-12": size === "sm",
        "h-24": size === "md",
        "h-28": size === "lg",
      })}
      alt='logo'
    />
  </span>
);
